import { useComponentRegistry } from '@bem-react/di';
import React from 'react';

import {
    IFilter,
    ISolution,
    ISolutionSection,
    TFiltersCategory,
    TLevel
} from 'client/common/types';
import cn from 'utils/cn';

import './index.css';

export interface ISolutionPageProps {
    solution: ISolution;
    solutionsUrl: string;
    filter: Pick<ISolutionSection, TFiltersCategory>;
    keywords?: string;
    levels?: TLevel[];
    shareServices: string[];
}

const CATEGORIES: TFiltersCategory[] = ['tasks', 'industries', 'products', 'companySize'];

export const cnSolutionInfo = cn('solution-info');

function SolutionPage({
    keywords,
    solution,
    solutionsUrl,
    filter,
    levels,
    shareServices
}: ISolutionPageProps) {
    const { MainLayout, Level, YaShare, Media } = useComponentRegistry('app');

    const tags: React.ReactNodeArray = [];

    const { slug, title, date, description, shareText } = solution;

    // TODO: Вынести в функцию для сбора тегов
    CATEGORIES.forEach(category =>
        tags.push(
            ...solution[category]
                .split(',')
                .map(categorySlug => filter[category].find(el => el && el.slug === categorySlug))
                .map((foundedFilter: IFilter | undefined) => (
                    foundedFilter && (
                        <a
                            key={foundedFilter.slug}
                            className={cnSolutionInfo('tag')}
                            href={`${solutionsUrl}?${category}=${foundedFilter.slug}`}
                            >{foundedFilter.name}
                        </a>
                    ))
                )
        )
    );

    return (
        <>
            <MainLayout transparent={false}>
                <Media
                    className={cnSolutionInfo()}
                    slug={slug}
                    keywords={keywords}
                    title={title}
                    dateString={date}
                    description={description}
                    shareServices={shareServices}
                    addonBefore={<div className={cnSolutionInfo('tags')}>{tags}</div>}
                    >
                    {levels && (
                        <div className={cnSolutionInfo('levels')}>
                            {/* eslint-disable-next-line complexity */}
                            {levels.map(level => {
                                let tagName;

                                if (level.type === 'results' && level.tag) {
                                    const { tag: rawTag } = level;
                                    const [category, tagSlug] = rawTag.split(':');

                                    const foundedFilter = filter[category as TFiltersCategory]
                                        .find(el => el && el.slug === tagSlug);

                                    tagName = (foundedFilter && foundedFilter.name) || '';
                                }

                                return (
                                    <React.Fragment key={level.order}>
                                        <Level
                                            className={cnSolutionInfo('level')}
                                            {...level}
                                            tag={tagName}
                                            />
                                        {level.og && (
                                            <YaShare
                                                id={`block-${level.order}`}
                                                blockOrder={level.order}
                                                className={cnSolutionInfo('share')}
                                                popup
                                                size="m"
                                                services={shareServices}
                                                />
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    )}
                    <div className={cnSolutionInfo('share-bottom')}>
                        {shareText && (
                            <div className={cnSolutionInfo('share-text')}>
                                {shareText}
                            </div>
                        )}
                        <YaShare
                            id={'share-bottom'}
                            className={cnSolutionInfo('share')}
                            size="m"
                            services={shareServices}
                            />
                    </div>
                </Media>
            </MainLayout>
        </>
    );
}

export default SolutionPage;
